import { UnitService } from "../../core/http/service/UnitService";
import { cleanMask } from "../../helpers/HelperFunctions";
import BaseResponse from "../../models/core/BaseResponse";
import Unit from "../../models/core/unit/Unit";
import UserAddress from "../../models/core/UserAddress";

export const RESET: string = 'RESET';
export const FETCH_UNITS: string = 'FETCH_UNITS';
export const FILTER_UNITS: string = 'FILTER_UNITS';
export const UPDATE_SELECTED_UNIT_MEDIC: string = 'UPDATE_SELECTED_UNIT_MEDIC';

const sendToAnalytics = (action: string = '', error: any = null) => {
    console.error(action, error);
}

export const fetchUnitList = () => {
    const service: UnitService = new UnitService()
    return async (dispatch: any) => {
        try {
            const response: any = await service.getUnits()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            const units: Unit[] = []

            baseResponse?.data?.forEach((data: any) => {
                units.push(new Unit().fromJSON(data))
            })

            dispatch({
                type: FETCH_UNITS,
                units: units
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
};

export const filterUnitList = (searchQuery: string) => {
    const service: UnitService = new UnitService()

    return async (dispatch: any) => {
        try {
            const response: any = await service.getUnits()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            const units: Unit[] = []

            baseResponse?.data?.forEach((data: any) => {
                units.push(new Unit().fromJSON(data))
            })

            const listaFiltrada = [...units.filter(unit => {
                const hasNomeUnidade = unit.nomeFantasia.toUpperCase().indexOf(searchQuery.toUpperCase())

                if (hasNomeUnidade !== -1) return true;

                const hasCnpj = unit.cnpj.toUpperCase().indexOf(cleanMask(searchQuery).toUpperCase())

                if (hasCnpj !== -1) return true;

                return false;
            })]

            dispatch({
                type: FILTER_UNITS,
                filteredUnits: listaFiltrada
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

const fillUnitObject = (values: any) => {
    const telefones = [cleanMask(values.telefone1).trim()]
    if (values.telefone2 !== '') {
        telefones.push(cleanMask(values.telefone2).trim())
    }
    const address: UserAddress = new UserAddress().fromJSON({
        logradouro: values.logradouro.trim(),
        numero: values.numero === '' || values.numero === null ? null : values.numero.trim(),
        complemento: values.complemento === '' || values.complemento === null ? null : values.complemento.trim(),
        bairro: values.bairro === '' ? null : values.bairro.trim(),
        cidade: values.cidade.trim(),
        estado: values.estado.trim(),
        cep: cleanMask(values.cep).trim()
    })

    const unit: Unit = new Unit().fromJSON({
        nomeFantasia: values.nomeFantasia.trim(),
        cnpj: cleanMask(values.cnpj).trim(),
        telefones: telefones,
        endereco: address
    })

    return unit;
}

export const registerUnit = (values: any) => {
    const service: UnitService = new UnitService()
    return async () => {
        try {
            const unidade: Unit = fillUnitObject(values)
            await service.registerUnit(unidade)
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}


export const updateUnit = (values: any, unitId: string) => {
    const service: UnitService = new UnitService()
    return async () => {
        try {
            const unidade: Unit = new Unit().fromJSON({ ...fillUnitObject(values), id: unitId })
            await service.editUnit(unidade, unitId)
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const activateOrDeactivateUnit = (unitId: string, isActivate: boolean) => {
    const service: UnitService = new UnitService()
    return async (dispatch: any) => {
        try {
            if (isActivate) {
                await service.activateUnit(unitId)
            } else {
                await service.inactivateUnit(unitId)
            }

        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const updateSelectedUnitPainelConsultas = (unit: any) => {
    return async (dispatch: any) => {
        try {
            dispatch({
                type: UPDATE_SELECTED_UNIT_MEDIC,
                unitSelectedAppointments: unit
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }

}


